import React from 'react';
import { Error401 } from '../../asset';
import { t } from 'i18next';
import PrimaryButton from '../../component/button/PrimaryButton';

const ErrorPage401 = () => {
  return (
    <div className='flex flex-col justify-center items-center'>
      <img src={Error401} alt='img-error-400' />
      <p className='font-sans font-bold text-4xl mt-[24px]'> Your Authorization Failed </p>
      <p className='font-sans font-bold text-2xl mt-[4px]'> Please try refreshing the page and fill in the correct details. </p>
      <PrimaryButton 
          styles='mt-[24px]'
          // action={() => setStartOpen(true)} 
          text={t("Back To Home")} 
        />
    </div>
  );
}

export default ErrorPage401;